import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { apiPostCandidateUnsubscribe } from '../../api/api';

export interface CandidateUnsubscribeState {
  status: 'idle' | 'loading' | 'success' | 'failed';
}

const initialState: CandidateUnsubscribeState = {
  status: 'idle',
};

export const postCandidateUnsubscribeAsync = createAsyncThunk(
  'candidateSignup/apiPostCandidateUnsubscribe',
  async (request: {email: String;}) => {
    const response = await apiPostCandidateUnsubscribe(request);

    // The value we return becomes the `fulfilled` action payload
    return response;
  }
)

export const candidateUnsubscribeSlice = createSlice({
  name: 'candidateUnsubscribe',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStatus: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.status = 'idle';
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(postCandidateUnsubscribeAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postCandidateUnsubscribeAsync.fulfilled, (state, action) => {
        // When the status field of the server response is 400
        // there was an error with the subscription request
        if(action.payload.status != null || action.payload.status !== 400) {
          state.status = 'success';
        } else {
          state.status = 'failed';
        }
      })
      .addCase(postCandidateUnsubscribeAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { clearStatus } = candidateUnsubscribeSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCandidateUnsubscribeStatus = (state: RootState) => state.candidateUnsubscribe.status;

export default candidateUnsubscribeSlice.reducer;